import { ProductTileType } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/ProductTileType";
import React from "react";

interface IProductTileTypeContext {
  productTileType?: ProductTileType;
}

export const ProductTileTypeContext =
  React.createContext<IProductTileTypeContext>({});
